import {
    ProjectRamen,
    ProjectTodo,
    ProjectWeather,
    PorjectKanban,
    ProjectDashboard,
} from '../assets/image'

export const data = [
    {
        id: 0,
        title: 'MOUNTAIN DASHBOARD',
        description:
            'A comprehensive statistics dashboard providing detailed information about the highest and most famous mountains in North and South America. Features interactive maps, elevation data, climate information, and advanced analytics for comparing and analyzing mountain data.',
        image: ProjectDashboard,
        github: 'https://github.com/MidnightYKT',
        url: 'https://dashboard-wheat-omega-28.vercel.app/',
        tools: [
            {
                id: 0,
                name: 'React',
            },
            {
                id: 1,
                name: 'TypeScript',
            },
            {
                id: 2,
                name: 'Tailwind',
            },
            {
                id: 3,
                name: 'Chart.js',
            },
            {
                id: 4,
                name: 'React Router',
            },
        ],
    },
    {
        id: 1,
        title: 'REACT RAMEN',
        description:
            'This is my mini online store for ordering ramen. In which I practiced using Redux, Axios, MockaApi and Typescript.',
        image: ProjectRamen,
        github: 'https://github.com/MidnightYKT/react-store-ramen',
        url: 'https://react-store-ramen-five.vercel.app/',
        tools: [
            {
                id: 0,
                name: 'React',
            },
            {
                id: 1,
                name: 'SCSS',
            },
            {
                id: 2,
                name: 'TypeScript',
            },
            {
                id: 3,
                name: 'mockaApi',
            },
            {
                id: 4,
                name: 'Redux',
            },
            {
                id: 5,
                name: 'Axios',
            },
        ],
    },
    {
        id: 2,
        title: 'WEATHER APP',
        description:
            'The weather app provides access to current weather conditions, including temperature, precipitation, wind speed, humidity, sunrise and sunset times, air pressure, feel like and visibility. The weather API was taken from www.weatherapi.com',
        image: ProjectWeather,
        github: 'https://github.com/MidnightYKT/weather-app',
        url: 'https://weather-app-three-gamma-31.vercel.app/',
        tools: [
            {
                id: 0,
                name: 'NEXT.JS',
            },
            {
                id: 1,
                name: 'Tailwind',
            },
            {
                id: 2,
                name: 'TypeScript',
            },
        ],
    },
    {
        id: 3,
        title: 'REACT KANBAN',
        description:
            'The Kanban Board React.js application is a dynamic project designed to streamline task management and enhance productivity. Developed with the modern web technology of React.js, this application serves as a visual project management tool.',
        image: PorjectKanban,
        github: 'https://github.com/MidnightYKT/kanban-board',
        url: 'https://kanban-board-iota-beige.vercel.app/',
        tools: [
            {
                id: 0,
                name: 'React',
            },
            {
                id: 1,
                name: 'Bootstrap',
            },
            {
                id: 2,
                name: 'ExpressJS',
            },
            {
                id: 3,
                name: 'Reactstrap',
            },
        ],
    },
    {
        id: 4,
        title: 'TODO LIST',
        description:
            'An application made to manage your tasks by providing an interfacefor adding, editing the mark of whether a task is done or not and deleting tasks.',
        image: ProjectTodo,
        github: 'https://github.com/MidnightYKT/todo-r',
        url: 'https://todo-r-theta.vercel.app/',
        tools: [
            {
                id: 0,
                name: 'React',
            },
            {
                id: 1,
                name: 'Redux',
            },
            {
                id: 2,
                name: 'Axios',
            },
        ],
    },
]
